
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/speed",
      function () {
        return require("private-next-pages/speed.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/speed"])
      });
    }
  